import * as PropTypes from "prop-types";

const DayType = PropTypes.arrayOf(PropTypes.shape({
  start: PropTypes.string,
  end: PropTypes.string,
}));

const ScheduleType = PropTypes.shape({
  monday: DayType,
  tuesday: DayType,
  wednesday: DayType,
  thursday: DayType,
  friday: DayType,
  saturday: DayType,
  sunday: DayType,
  holiday: DayType,
});

export default ScheduleType;
